import * as Prismic from "@prismicio/client";

const apiEndpoint = "https://superbeneficios.prismic.io/api/v2";
export const client = Prismic.createClient(apiEndpoint, {
  accessToken: process.env.PRISMIC_ACCESS_TOKEN,
});
